import {
  canEditMemberPermissions,
  canViewMemberDetailsPermissions,
} from '../../../config/accessPolicies/accessPolicies';
import EditMemberModal from '../../../styledComponents/Modals/EditMemberModal/EditMemberModal';
import AAMembersList from '../../../styledComponents/ProductMembersList/AAMembersList/AAMembersList';
import { pageFilters } from './membersAirAmbulance.const';
import { useMembersAirAmbulance } from './membersAirAmbulance.hooks';

const MembersAirAmbulancePage = () => {
  const {
    membersLoading,
    pageListMembers,
    onRowClickHandler,
    rowEditHandler,
    onMemberEditedHandler,
    aaMembershipPricing,
  } = useMembersAirAmbulance();

  return (
    <>
      <EditMemberModal onMemberEdited={onMemberEditedHandler} />
      <AAMembersList
        tableProps={{
          onRowClick: onRowClickHandler,
          onRowEdit: rowEditHandler,
          isLoading: membersLoading,
          data: pageListMembers,
          canViewDetailsPermissions: canViewMemberDetailsPermissions,
          canEditPermissions: canEditMemberPermissions,
        }}
        toolsProps={{
          availableFilters: pageFilters,
          standardPricing: aaMembershipPricing,
        }}
      />
    </>
  );
};

export default MembersAirAmbulancePage;
